import { h } from 'preact';
import style from './style';

export const ChangeBoxes = ({ boxes }) => (
	<div class={style['change-boxes']}>
		{ boxes.map((box) => (
			<div class={style['change-box'] + ' ' + box.className}>
				<div class={style.label}>{ box.label }</div>
				<div class={style.sub}>{ box.sub }</div>
				<div class={style.indicator}>{ box.value }</div>
			</div>
		))}
	</div>
);
